import React, { Dispatch, useEffect, useReducer } from "react"
import { Route, RouteComponentProps, withRouter } from "react-router-dom"
import { useHistory, useLocation } from "react-router"
import { find, get, includes } from "lodash"

import { SearchTemplate } from "components/templates/tool/search"
import { StockBenefitTemplate } from "components/templates/tool/stockBenefit"
import { ScreeningTemplate } from "components/templates/tool/screenig"
import {
  DetailSearchActionType,
  DetailSearchStateType,
  ScreeningActionType,
  ScreeningStateType,
  useBenefitActionType,
  useBenefitStateType,
  useBenefitReducer,
  useDetailSearchReducer,
  useDetailSearchResult,
  useScreeningReducer,
  useScreeningResult,
  useStockBenefitResult,
  useDetailCompareResult,
  DetailCompareResult,
} from "components/actions/tool"
import { DETAIL_SEARCH_CONDITIONS, SP_SECTOR_LIST } from "config/const"
import { APIResponse } from "redux/apis/types"
import { ToolChildrenRoutesType } from "routes/routes"
import { parseQueryString } from "utils/util"
import {
  initRegisterLoad,
  RegisterSymbolStateType,
} from "redux/ducks/RegisterSymbol"
import store from "redux/store"
import { connect } from "react-redux"

export type DetailSearchProps = {
  searchState: DetailSearchStateType
  searchAction: Dispatch<DetailSearchActionType>
  data: APIResponse.Res
  searchCompareData: Array<APIResponse.Res>
  registerSymbol: RegisterSymbolStateType
}

type SearchType = {
  searchResult?: APIResponse.Res
  searchState?: DetailSearchStateType
  searchAction?: Dispatch<DetailSearchActionType>
  searchCompareData?: Array<APIResponse.Res>
  registerSymbol?: RegisterSymbolStateType
}

export type ScreeningType = {
  screeningResult?: APIResponse.Res
  screeningState?: ScreeningStateType
  screeningAction?: Dispatch<ScreeningActionType>
}

type StockBenefitType = {
  stockBenefitResult?: APIResponse.Res
  stockBenefitState?: useBenefitStateType
  stockBenefitAction?: Dispatch<useBenefitActionType>
}

type ToolType = SearchType & ScreeningType & StockBenefitType

const initialDetailSearchState: DetailSearchStateType = {
  load: false,
  openToggle: [],
  keyword: "",
  markets: [],
  jpIndustry: [],
  spIndustry: [],
  compare: [],
  page: 0,
  isComparePage: false,
  sort: null,
}

const initialState: useBenefitStateType = {
  month: [new Date().getMonth()],
  category: [],
  price: [],
  page: 0,
  sort: ["Symbol", true],
  displayToggle: [],
  load: false,
}

const initialScreeningState: ScreeningStateType = {
  load: false,
  openToggle: [],
  recommendFlag: null,
  markets: [],
  jpIndustry: [],
  spIndustry: [],
  detail: [],
  columnType: DETAIL_SEARCH_CONDITIONS.TABLE_OPTION[0].id,
  page: 0,
  sort: null,
}

export const Search: React.FC<ToolType> = props => {
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    const setCode = !!location.search ? parseQueryString(location.search) : null
    if (!!setCode) {
      const codeList = find(SP_SECTOR_LIST, {
        SPSecCode: get(setCode, "code", null),
      })
      props.searchAction({
        type: "LOAD_SYMBOL_DETAIL",
        id: get(codeList, "id"),
      })
      history.push(location.pathname)
    }
  }, [location])
  return (
    <SearchTemplate
      searchState={props.searchState}
      searchAction={props.searchAction}
      data={props.searchResult}
      searchCompareData={props.searchCompareData}
      registerSymbol={props.registerSymbol}
    />
  )
}

export const StockBenefit: React.FC<ToolType> = props => {
  //初期ロード
  useEffect(() => {
    props.stockBenefitAction({ type: "LOAD_BENEFIT" })
  }, [])

  return (
    <StockBenefitTemplate
      response={props.stockBenefitResult}
      stockBenefitState={props.stockBenefitState}
      stockBenefitAction={props.stockBenefitAction}
    />
  )
}

export const Screening: React.FC<ToolType> = props => {
  return (
    <ScreeningTemplate
      screeningResult={props.screeningResult}
      screeningState={props.screeningState}
      screeningAction={props.screeningAction}
    />
  )
}

const Tool: React.FC<
  RouteComponentProps & {
    routes: ToolChildrenRoutesType
    registerSymbol: RegisterSymbolStateType
  }
> = props => {
  useEffect(() => {
    if (props.location.pathname === "/tools")
      props.history.replace("/tools/search")
    if (includes(props.location.pathname, "search"))
      store.dispatch(initRegisterLoad())
  }, [props.location])
  const [screeningState, screeningAction] = useReducer(
    useScreeningReducer,
    initialScreeningState
  )
  const screeningResult = useScreeningResult(screeningState, () =>
    screeningAction({ type: "LOADED_SCREENING" })
  )

  const [stockBenefitState, stockBenefitAction] = useReducer(
    useBenefitReducer,
    initialState
  )
  const stockBenefitResult = useStockBenefitResult(stockBenefitState, () =>
    stockBenefitAction({ type: "LOAD_BENEFIT" })
  )

  const [searchState, searchAction] = useReducer(
    useDetailSearchReducer,
    initialDetailSearchState
  )
  const searchResult = useDetailSearchResult(searchState, () =>
    searchAction({ type: "LOADED_DETAIL" })
  )

  const searchCompareData: DetailCompareResult = useDetailCompareResult(
    searchState.compare,
    searchState.isComparePage
  )

  const registerSymbol = props.registerSymbol

  return (
    <div className="tool">
      {props.routes.map((li, i) => (
        <Route
          exact
          key={i}
          path={li.path}
          render={() =>
            React.createElement<ToolType>(li.component, {
              searchResult,
              searchState,
              searchAction,
              screeningResult,
              screeningState,
              screeningAction,
              stockBenefitResult,
              stockBenefitState,
              stockBenefitAction,
              searchCompareData,
              registerSymbol,
            })
          }
        />
      ))}
    </div>
  )
}

export default connect((state: { registerSymbol: RegisterSymbolStateType }) => {
  return { registerSymbol: state.registerSymbol }
})(withRouter(Tool))
